import styled from "@emotion/styled";
function startsWith(str, prefix) {
  return str.startsWith(prefix);
}
export var defaultArrowSize = 4;
export var FlyoutArrow = styled("div")({
  width: 0,
  height: 0,
  borderStyle: "solid"
}, function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultArrowSize : _ref$size;
  return {
    borderWidth: "".concat(size, "px")
  };
},
// Choose the right border color based on positioning.
function (_ref2) {
  var backgroundColor = _ref2.backgroundColor,
    placement = _ref2.placement;
  return {
    borderRightColor: startsWith(placement, "right") && backgroundColor || "transparent",
    borderLeftColor: startsWith(placement, "left") && backgroundColor || "transparent",
    borderTopColor: startsWith(placement, "top") && backgroundColor || "transparent",
    borderBottomColor: startsWith(placement, "bottom") && backgroundColor || "transparent"
  };
},
// Offset the arrow a bit to account for its size.
function (_ref3) {
  var placement = _ref3.placement,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? defaultArrowSize : _ref3$size;
  return {
    bottom: startsWith(placement, "top") ? "-".concat(size * 2, "px") : "initial",
    top: startsWith(placement, "bottom") ? "-".concat(size * 2, "px") : "initial",
    right: startsWith(placement, "left") ? "-".concat(size * 2, "px") : "initial",
    left: startsWith(placement, "right") ? "-".concat(size * 2, "px") : "initial"
  };
});
//# sourceMappingURL=FlyoutArrow.js.map